import axios from "axios";
// import _sortBy from "lodash/sortBy";
import _isEmpty from "lodash/isEmpty";
import _size from "lodash/size";
import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        baseurl: '/checks',
        checksList: false,
        checkCount: false,
        message: false,
        error: false
        },
    mutations: {
        setCheck (state, val) {
            Vue.set(state.checksList, val._id, val);
        },
        setList (state, val) {
            // console.log('mutating checksList', val);
            // state.checksList = val;
            Vue.set(state, 'checksList', val);
            setTimeout(function(){state.checkCount = _size(state.checksList); }, 33);
        },
        setError (state, val) {
            state.error = Object.assign({}, val);
        }
    },
    actions: {
        getChecksList ({ commit, state }, data) {
            if ( false || ((!data || !data.nocache) && !_isEmpty(state.checksList)) ){
                // caching here has some issues since we might set individual checks but not have all of them.
                // Leaving as a placeholder in case we want to implement later.
                return Promise.resolve();
            } else {
                // console.log('checks/getChecksList fetching from server');
                return axios.get(state.baseurl + "/list_wa")
                    .then( (result) => {
                        // console.log("Checks List", result.data);
                        if (result && result.data) {
                            this.commit('checks/setList', result.data);
                        }
                    })
                    .catch( (error) => {
                        console.log("ERROR in checks.getChecksList", error);
                    })
            }
        },

        getCheck ({ commit, state }, options) {
            let params = {};

            options.jobid = options.jobid || options._id;

            if(!options || !options.jobid){
                console.log("Missing job id");
                return Promise.resolve();
            }

            return axios.post(state.baseurl + '/get/' + options.jobid, params)
                .then( (result) => {
                    if(result.data){
                        commit('setCheck', result.data);
                        commit('setError', false);
                        return result.data
                    }
                })
                .catch( (error) => {
                    console.log("ERROR getting check", error. response || error);
                    error = (error && error.response) || {
                        response: 500,
                        data: {}
                    }
                    commit('setError', {
                        status: error.response.status,
                        statusText: error.response.statusText,
                        message: ((error.response.data && error.response.data.error) || "Check Not Found")
                    })
                })


        },

        setCheck ({ commit, state }, data) {
            let url = false;
            let params = {}
            if(!data || typeof data !== "object" || !data._id){
                return Promise.resolve();
            } else if(_size(data) === 2){
                console.log('setCheck one field');
                let cid = data._id;
                delete data._id;

                let field = Object.keys(data)[0];
                switch( field ){
                    case 'public':
                        url = "/togglepublic/" + cid;
                        break;
                    default:
                        return Promise.resolve();
                }
            } else {
                console.log('setCheck with more than one field')
            }

            if(url){
                console.log("setCheck", state.baseurl + url, params);
                // return Promise.resolve(state.baseurl + url, params);
                return axios.post(state.baseurl + url, params)
                    .then( (result) => {
                        console.log('setCheck', result || status);
                        return result.data;
                    })
            } else {
                return Promise.resolve();
            }
        }
    }
}
